module.exports = __webpack_public_path__ + "img/product.5e42f56a.svg";